// Live Casino
import { default as LiveDG } from "./live/live-DG.webp";
import { default as LiveAB } from "./live/live-AB.webp";
import { default as LiveSA } from "./live/live-SA.webp";
import { default as LiveWM } from "./live/live-WM.webp";
import { default as LiveYB } from "./live/live-YB.webp";

// Slot
import { default as SlotGR } from "./slots/slot-GR.webp";
import { default as SlotDB } from "./slots/slot-DB.webp";
import { default as SlotATG } from "./slots/slot-ATG.webp";
import { default as SlotBNG } from "./slots/slot-BNG.webp";
import { default as SlotDT } from "./slots/slot-DT.webp";
import { default as SlotRSG } from "./slots/slot-RSG.webp";
import { default as SlotRTG } from "./slots/slot-RTG.webp";
import { default as SlotZG } from "./slots/slot-ZB.webp";

// Board Game
import { default as BoardGR } from "./board/board-GR.webp";
import { default as BoardGFGD } from "./board/board-GFGD.webp";
import { default as Board9K } from "./board/board-9K.webp";
import { default as BoardATG } from "./board/board-ATG.webp";

// Sport
import { default as SportSUPER } from "./sport/sport-SUPER.webp";
import { default as SportOBSB } from "./sport/sport-Alaba.webp";

// Fishing
import { default as FishGR } from "./fishing/fish-GR.webp";
import { default as FishSP } from "./fishing/fish-SP.webp";

// Lottery
import { default as Lottery9K } from "./lottery/lottery-9K.webp";
import { default as LotterySUPER } from "./lottery/lottery-SUPER.webp";
import { default as LotteryATG } from "./lottery/lottery-ATG.webp";

export const ImgProvider = {
  LiveDG,
  LiveAB,
  LiveSA,
  LiveWM,
  LiveYB,

  SlotGR,
  SlotDB,
  SlotATG,
  SlotBNG,
  SlotDT,
  SlotRSG,
  SlotRTG,
  SlotZG,

  BoardGR,
  BoardGFGD,
  Board9K,
  BoardATG,

  SportSUPER,
  SportOBSB,

  FishGR,
  FishSP,

  Lottery9K,
  LotterySUPER,
  LotteryATG,
};
